import WaitingExecutionIcon from './component'

export default WaitingExecutionIcon
